import { useRef } from "react";
import { CircularProgress } from "@mui/material";
import { UploadOutlined } from "@mui/icons-material";
import { colors } from "../../../../theme/theme";
import {
  AvatarBox,
  AvatarImage,
  AvatarOverlay,
  FieldLabel,
  ImageUploadWrapper,
} from "../../shared/practitionerForm.styles";
import { LABEL_BACKGROUND_PICTURE } from "../ResourcesModal.constants";

const CoverPictureSection = ({
  coverPicture,
  coverPictureLoading,
  onFileSelect,
  onImageLoad,
  onImageError,
}) => {
  const inputRef = useRef(null);

  const handleBrowse = () => {
    inputRef.current?.click();
  };

  return (
    <ImageUploadWrapper>
      <FieldLabel>{LABEL_BACKGROUND_PICTURE}</FieldLabel>
      <AvatarBox onClick={handleBrowse}>
        <input
          ref={inputRef}
          type="file"
          style={{ display: "none" }}
          accept="image/*"
          onChange={onFileSelect}
        />
        {coverPicture ? (
          <>
            <AvatarImage
              src={coverPicture}
              alt="cover"
              style={{
                opacity: coverPictureLoading ? 0 : 1,
                objectFit: "contain",
              }}
              onLoad={onImageLoad}
              onError={onImageError}
            />
            {coverPictureLoading && (
              <AvatarOverlay>
                <CircularProgress size={32} sx={{ color: colors.primary }} />
              </AvatarOverlay>
            )}
          </>
        ) : (
          <UploadOutlined sx={{ color: colors.primary }} />
        )}
        </AvatarBox>
    </ImageUploadWrapper>
  );
};

export default CoverPictureSection;
